import t from"styled-components";import"react";import o from"prop-types";import{calculateRem as r}from"@vds-core/utilities";import{BodyConfig as p,TypographyConfig as i}from"@vds-core/typography";o.object,o.string,o.string,r(4),i.getTypescale(),t.div.withConfig({displayName:"InputTextWrapper",componentId:"VDS__sc-1wiyhm4-0"})`
  display: block;
  margin-top: ${function({margin:t,typescale:o}){return"VDS"===o?r(8):t}};
`;
